import { http } from '@/app/lib/http/client'

// 1. Interfaz Principal (Como viene de la base de datos/API)
export interface TaxItem {
    id: number
    name: string
    percentage: number
    type: string
    created_at?: string
    updated_at?: string
}

// 2. Interfaz para Crear (Lo que mandas en el POST)
export interface CreateTaxPayload {
    name: string
    percentage: number
    type: string
}

// 3. Interfaz para Editar (Lo que mandas en el PUT, usualmente opcional)
export interface UpdateTaxPayload {
    name?: string
    percentage?: number
    type?: string
}

// 4. El Objeto de Servicio con todas las peticiones
export const taxesService = {
    // Obtener todos (con paginación/búsqueda opcional)
    async getItems(params?: { per_page?: number; search?: string; page?: number }) {
        const response = await http.get('/taxes', { params }) // TODO: CAMBIAR RUTA
        return response.data
    },

    // Obtener uno solo por ID
    async getItem(id: number) {
        const response = await http.get(`/taxes/${id}`) // TODO: CAMBIAR RUTA
        return response.data
    },

    // Crear
    async createItem(payload: CreateTaxPayload) {
        const response = await http.post('/taxes', payload) // TODO: CAMBIAR RUTA
        return response.data
    },

    // Actualizar
    async updateItem(id: number, payload: UpdateTaxPayload) {
        const response = await http.put(`/taxes/${id}`, payload) // TODO: CAMBIAR RUTA
        return response.data
    },

    // Eliminar
    async deleteItem(id: number) {
        const response = await http.delete(`/taxes/${id}`) // TODO: CAMBIAR RUTA
        return response.data
    },
}
